/* eslint-disable no-nested-ternary */
import { Autocomplete, Chip, CircularProgress, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import React from "react";
import { useSelector } from "react-redux";

function AssignTo({ formData, users, usersLoading, templateData }) {
  const loginUser = useSelector((state) => state.loginUser.loginUserState);
  const { values, errors, touched, setFieldValue } = formData;
  const { assignTo } = values;

  return (
    <MDBox>
      <MDBox>
        <Grid container spacing={3} p={1}>
          <Grid item xs={12}>
            <MDBox>
              <MDTypography variant="h5" fontWeight="bold">
                Template Assignment
              </MDTypography>
              <MDTypography variant="subtitle2" sx={{ color: "#7b809a" }}>
                Who should receive reports from this template?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              fullWidth
              id="assign_to"
              multiple
              disableClearable
              disableCloseOnSelect
              options={users.filter((user) => {
                if (user?.UserCompaniesLinks?.disabledAt) return false;
                if (
                  templateData?.CoachupUserTemplates?.find(
                    (templateUser) =>
                      templateUser?.assignedBy !== loginUser?.id &&
                      templateUser?.userId === user?.id
                  )
                ) {
                  return false;
                }
                if (user?.id === loginUser?.id) {
                  return false;
                }
                return true;
              })}
              onChange={(_, value) => {
                setFieldValue(
                  "assignTo",
                  value.map((user) => user.id)
                );
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) => option.name}
              value={users.filter((user) => assignTo.includes(user.id)) || []}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.name}
                </li>
              )}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip
                    label={option.name}
                    {...getTagProps({ index })}
                    disabled={option?.UserCompaniesLinks?.disabledAt}
                  />
                ))
              }
              renderInput={(params) => (
                <MDInput
                  {...params}
                  variant="standard"
                  placeholder="Assign To"
                  label="Assign To"
                  error={touched?.assignTo && Boolean(errors?.assignTo)}
                  helperText={touched?.assignTo && errors?.assignTo}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {usersLoading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default AssignTo;
